import { normalizeAddressingLine } from './normalizeAddressingLine'

const SIREN_LENGTH = 9

export const getSirenFromAddressingLine = (addressingLine: string): string =>
  normalizeAddressingLine(addressingLine).slice(0, SIREN_LENGTH)
